import { Component, OnInit } from '@angular/core';
import { AuthService, User } from 'src/app/core/authentication/auth.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    constructor( public authService: AuthService ) { }

    ngOnInit(): void {
        this.authService.login();
    }

}
